import React, { useEffect, useState } from "react";
import { Form, Button, InputGroup, Spinner, ListGroup } from "react-bootstrap";
import * as ingresosApi from "../../api/ingresos";
import { formatoNumero } from "../../utils/moneda";

/** Barra para registrar ingresos del mes (monto + motivo) que suman al saldo actual. */
export default function IngresosPanel({ cuentaId, onCambio }) {
  const [ingresos, setIngresos] = useState([]);
  const [motivo, setMotivo] = useState("");
  const [monto, setMonto] = useState("");
  const [guardando, setGuardando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [expandido, setExpandido] = useState(false);

  const cargar = async () => {
    if (!cuentaId) return;
    setCargando(true);
    try {
      const hoy = new Date();
      setIngresos(await ingresosApi.listarIngresosRecientes(cuentaId, hoy.getMonth() + 1, hoy.getFullYear()));
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargar(); }, [cuentaId]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAgregar = async (e) => {
    e.preventDefault();
    setGuardando(true);
    try {
      await ingresosApi.registrarIngreso({ cuentaId, monto: Number(monto), motivo });
      setMotivo(""); setMonto("");
      await cargar();
      onCambio?.();
    } finally {
      setGuardando(false);
    }
  };

  const eliminar = async (id) => {
    await ingresosApi.eliminarIngreso(id);
    await cargar();
    onCambio?.();
  };

  return (
    <div className="fs-card mt-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="fw-semibold"><i className="bi bi-arrow-down-circle text-fs-ingreso me-2"></i>Ingresos del mes</div>
        <Button size="sm" variant="link" className="text-decoration-none" onClick={() => setExpandido((v) => !v)}>
          {expandido ? "Ocultar historial" : "Ver historial"}
        </Button>
      </div>

      <Form onSubmit={handleAgregar}>
        <div className="row g-2 align-items-end">
          <div className="col-12 col-sm-6">
            <Form.Control value={motivo} onChange={(e) => setMotivo(e.target.value)} required placeholder="Motivo del ingreso (sueldo, bono, venta...)" />
          </div>
          <div className="col-8 col-sm-4">
            <InputGroup>
              <InputGroup.Text>$</InputGroup.Text>
              <Form.Control type="number" step="0.01" min="0.01" value={monto} onChange={(e) => setMonto(e.target.value)} required />
            </InputGroup>
          </div>
          <div className="col-4 col-sm-2">
            <Button type="submit" variant="primary" className="w-100" disabled={guardando}>
              {guardando ? <Spinner size="sm" animation="border" /> : "Agregar"}
            </Button>
          </div>
        </div>
      </Form>

      {expandido && (
        <ListGroup variant="flush" className="mt-3">
          {cargando ? <Spinner animation="border" size="sm" /> : (
            ingresos.length ? ingresos.map((i) => (
              <ListGroup.Item key={i.ingresoId} className="d-flex justify-content-between align-items-center px-0">
                <div>
                  <div>{i.motivo}</div>
                  <div className="text-muted small">{new Date(i.fecha).toLocaleDateString("es-ES")}</div>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-fs-ingreso fw-semibold">+${formatoNumero(i.monto)}</span>
                  <Button size="sm" variant="outline-danger" onClick={() => eliminar(i.ingresoId)}>
                    <i className="bi bi-trash"></i>
                  </Button>
                </div>
              </ListGroup.Item>
            )) : <div className="text-muted small py-2">Sin ingresos registrados este periodo.</div>
          )}
        </ListGroup>
      )}
    </div>
  );
}
